module.exports = __webpack_public_path__ + "assets/images/imc_g.883e18e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/imc_g.png
// module id = 746
// module chunks = 1